<div class="descadastro-pagina center-center">
  <div class="descadastro-card container-card-generico">
    <img src="./assets/clari-talk-logo-texto.png" alt="ClariTalk" class="descadastro-logo img-fluida" />

    @if (carregando()) {
      <p class="descadastro-texto">Confirmando o seu pedido...</p>
    } @else if (resultado() === ResultadoDescadastroEnum.LINK_INVALIDO) {
      <img src="./assets/icones/erro.svg" alt="" class="descadastro-icone" />
      <h1 class="descadastro-titulo">Link inválido</h1>
      <p class="descadastro-texto">Não foi possível processar essa solicitação de descadastro.</p>
    } @else {
      <div class="descadastro-icone descadastro-icone-sucesso">
        <img src="./assets/icones/icone-descadastrado-check.svg"/>
      </div>
      @if (resultado() === ResultadoDescadastroEnum.JA_DESCADASTRADO) {
        <h1 class="descadastro-titulo">Você já está descadastrado</h1>
        <p class="descadastro-texto">
          O e-mail <strong>{{ email() }}</strong> já estava na nossa lista de exclusão. Você não recebe mais e-mails da ClariTalk.
        </p>
      } @else {
        <h1 class="descadastro-titulo">Você foi descadastrado</h1>
        <p class="descadastro-texto">
          Pronto! O e-mail <strong>{{ email() }}</strong> foi removido da nossa lista de envios e adicionado à lista de exclusão. A partir de agora, você não receberá mais e-mails da ClariTalk.
        </p>
      }
    }

    <div class="divider descadastro-divisor"></div>
  </div>
</div>
